import React, { useState, useEffect, useContext, useMemo } from "react";
import Header from "../../components/dashboard/header";
// import Sidebar from "../../components/dashboard/sidebar";
import SideMenu from "../student/SideMenu"
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Loader from "../../components/loader";
import SessionPopup from "../SessionPopup"
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import DataTable from "react-data-table-component";
import parse from "react-html-parser";

import rotate_right from '../../assets/images/rotate_right.svg';

import Tooltip from '@mui/material/Tooltip'
let { lambda, appname } = window.app;

const Fellow = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [moduleError, setModuleError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [success, setSuccess] = useState(false);
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [editFellow, setEditFellow] = useState({ name: '', phone: '', userType: '', status: '', emailid: '' });
    const [permission, setPermission] = useState({});
    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [selectedModules, setSelectedModules] = useState([]);
    const [moduleOptions, setModuleOptions] = useState([]);

    const [image, setImg] = useState('');
    const [manager, setManagers] = useState({});
    const [loader, setLoader] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);
    const [checkStatus, setCheckStatus] = useState(false);
    const [modules, setModules] = useState([]);
    const [invalidContent, setInvalidContent] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [moduleToDelete, setModuleToDelete] = useState(null);
    const [assignedModuleIds, setAssignedModuleIds] = useState([]);
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getFellowInfo();
            fetchModuleInfoData()

        }
        // getManagers();
        //  GetCountries();
        // userActivity();
    }, []);

    function onConfirm() {
        GetTimeActivity()
        setSuccess(false);
        if (!id) {
            navigate("/users")
        }

    };

    const getFellowInfoOld = (e) => {
        setLoader(true)
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/getFellowsList?appname=' + appname + '&fellowUserid=' + id,
        })
            .then(function (response) {
                //  console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                }
                else {
                    if (response?.data?.result.length > 0) {
                        setEditFellow(response?.data?.result?.[0]);
                        if (response?.data?.result?.[0] && response?.data?.result?.[0]?.permissions) {
                            setPermission(response?.data?.result?.[0]?.permissions)
                        }
                    } else {
                        setInvalidContent(true)
                    }
                }
            });
    }
    const getFellowInfo = async (e) => {
        try {
            console.log("[getFellowInfo] API call started");
            setLoader(true);

            GetTimeActivity();

            const token = localStorage.getItem("token");
            console.log("[getFellowInfo] token:", token);

            const url =
                lambda +
                '/getFellowsList?appname=' +
                appname +
                '&fellowUserid=' +
                id;

            console.log("[getFellowInfo] Request URL:", url);

            const response = await axios({
                method: 'GET',
                url: url,

            });

            console.log("[getFellowInfo] API response:", response);

            const result = response?.data?.result;

            if (!result) {
                console.warn("[getFellowInfo] Empty result from API");
                setInvalidContent(true);
                return;
            }

            if (result === "Invalid token or Expired") {
                console.warn("[getFellowInfo] Session expired");
                setShowSessionPopupup(true);
                return;
            }

            if (Array.isArray(result) && result.length > 0) {
                console.log("[getFellowInfo] Fellow data found");

                const fellowData = result[0];
                setEditFellow(fellowData);


                const selectedOptions = Array.isArray(fellowData?.assignedModules)
                    ? fellowData?.assignedModules.map(item => ({
                        value: item.moduleid,
                        label: item.modulename,
                        description: item?.description,
                        participated: item?.participated || false
                    }))
                    : [];

                setSelectedModules(selectedOptions)

                const moduleIds = selectedOptions.map(mod => mod.value);
                setAssignedModuleIds(moduleIds);
                if (fellowData?.permissions) {
                    console.log("[getFellowInfo] Permissions:", fellowData.permissions);
                    setPermission(fellowData.permissions);
                }
            } else {
                console.warn("[getFellowInfo] No fellow data available");
                setInvalidContent(true);
            }

        } catch (error) {
            console.error("[getFellowInfo] API error:", error);

            // Optional: handle network / server errors separately
            if (error?.response) {
                console.error(
                    "[getFellowInfo] Server error:",
                    error.response.status,
                    error.response.data
                );
            }

            setInvalidContent(true);

        } finally {
            console.log("[getFellowInfo] API call finished");
            setLoader(false);
        }
    };


    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/fellows')
    }
    const stripHtml = (html = "") => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };
    const isHtml = (str = "") => /<\/?[a-z][\s\S]*>/i.test(str);

    const decodeHtmlEntities = (str = "") => {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    };

    const DescriptionColumn = {
        name: "Module Description",
        sortable: true,

        selector: (row) => {
            const value = row?.description || "";
            return isHtml(value) ? decodeHtmlEntities(stripHtml(value)) : decodeHtmlEntities(value);
        },

        cell: (row) => {
            const value = row?.description || "";
            if (!value) return "-";

            const html = isHtml(value);
            const plainText = html ? decodeHtmlEntities(stripHtml(value)) : decodeHtmlEntities(value);

            // Trim display text
            const words = plainText.split(/\s+/);
            const isLong = words.length > 100;
            const displayText = isLong
                ? words.slice(0, 100).join(" ") + "… Read more"
                : plainText;

            // clean <h3> margins
            const cleanedHtml = html
                ? value.replace(/^<h3[^>]*>/i, "").replace(/<\/h3>$/i, "")
                : null;

            // Tooltip content
            const tooltipTitle = html ? (
                <div
                    style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        padding: "10px",
                        fontSize: "12px",
                        lineHeight: "20px",
                    }}
                >
                    {parse(cleanedHtml)}
                </div>
            ) : (
                plainText
            );

            return (
                <Tooltip
                    title={tooltipTitle}
                    placement="right-start"
                    classes={{ tooltip: "my-tooltip-parent" }}
                    PopperProps={{
                        modifiers: [
                            {
                                name: "preventOverflow",
                                options: {
                                    boundary: "viewport",
                                },
                            },
                        ],
                    }}
                >
                    <div
                        style={{
                            maxWidth: "100%",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "default",
                            fontSize: "12px",
                            lineHeight: "20px",
                        }}
                    >
                        {displayText}
                    </div>
                </Tooltip>
            );
        },
    };

    const columns = [
        {
            name: 'Module Name',
            selector: row => row?.label ?? "",
            sortable: true,
            width: '200px'
        },
        DescriptionColumn,

        // {
        //     name: 'Actions',
        //     cell: (row) => (
        //         <div className="d-flex">
        //             {!row.isParticipated && (
        //                 <a
        //                     onClick={() => handleDeleteModule(row.value)}
        //                     className='text-danger action-button'
        //                     style={{ cursor: 'pointer' }}
        //                     title="Delete Module"
        //                 >
        //                     <i className="mdi mdi-delete font-size-18"></i>
        //                 </a>
        //             )}
        //             {row.isParticipated && (
        //                 <span className="text-muted" title="Cannot delete - User has participated">
        //                     <i className="mdi mdi-lock font-size-18"></i>
        //                 </span>
        //             )}
        //         </div>
        //     ),
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        //     width: '100px'
        // }

        {
            name: 'Actions',
            cell: (row) => {
                const isParticipated = row.participated === true;

                // Tooltip content
                const tooltipTitle = isParticipated
                    ? "Cannot delete: Doctor has already submitted this module"
                    : "Delete module";

                return (
                    <div className="d-flex">
                        <Tooltip
                            title={tooltipTitle}
                            placement="top"
                            classes={{ tooltip: "my-tooltip-parent" }}
                        >
                            <span>
                                <a
                                    onClick={() => !isParticipated && handleDeleteModule(row.value)}
                                    className={`action-button ${isParticipated ? 'text-muted' : 'text-danger'}`}
                                    style={{
                                        cursor: isParticipated ? 'not-allowed' : 'pointer',
                                        opacity: isParticipated ? 0.6 : 1,
                                        pointerEvents: isParticipated ? 'none' : 'auto'
                                    }}
                                >
                                    <i className={`mdi ${isParticipated ? 'mdi-lock' : 'mdi-delete'} font-size-18`}></i>
                                </a>
                            </span>
                        </Tooltip>
                    </div>
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '100px'
        }
    ];
    const handleDeleteModule = (moduleValue) => {
        setModuleToDelete(moduleValue);
        setShowDeleteAlert(true);
    };

    const confirmDeleteModule = () => {
        if (moduleToDelete) {
            // Remove module from selectedModules
            const updatedModules = selectedModules.filter(
                mod => mod.value !== moduleToDelete
            );

            setSelectedModules(updatedModules);
            setEditFellow(prev => ({
                ...prev,
                assignedModules: updatedModules.map(opt => opt.value)
            }));
            const moduleIds = updatedModules.map(mod => mod.value);
            setAssignedModuleIds(moduleIds);
            setShowDeleteAlert(false);
            setModuleToDelete(null);
        }
    };

    const handleModuleChange = (selectedOptions) => {
        if (!selectedOptions) {
            return;
        }

        // Filter out newly added modules only
        const newModules = selectedOptions.filter(
            option => !selectedModules.find(mod => mod.value === option.value)
        );

        // Add new modules with isParticipated: false (can be deleted)
        const updatedModules = [
            ...selectedModules,
            ...newModules.map(mod => ({
                ...mod,
                description: moduleOptions.find(opt => opt.value === mod.value)?.description || '',
                participated: false
            }))
        ];

        setSelectedModules(updatedModules);
        setEditFellow(prev => ({
            ...prev,
            assignedModules: updatedModules.map(opt => opt.value)
        }));
        const moduleIds = updatedModules.map(mod => mod.value);
        setAssignedModuleIds(moduleIds);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log('typeeeeeeeeee', value);
        console.log('nameeeee', name);

        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditFellow(prev => ({ ...prev, [name]: value }));
        }

        if (name === "phoneNumber") {
            const numericValue = value.replace(/\D/g, "").slice(0, 10);
            setEditFellow(prev => ({ ...prev, phoneNumber: numericValue }));
            return;
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditFellow(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditFellow(prev => ({ ...prev, [name]: value }));
        }

        else {
            setEditFellow(prev => ({ ...prev, [name]: value }));
        }
    };



    const handleAddUser = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            createuser();
        }
    }

    function formvalidation() {
        GetTimeActivity();
        let formIsValid = true;

        if (!Array.isArray(selectedModules) || selectedModules.length === 0) {
            setModuleError("Please select at least one module");
            setTimeout(() => setModuleError(""), 3000);
            formIsValid = false;
        }

        return formIsValid;
    }
    console.log('assignedModuleIds---------------------------------', assignedModuleIds)

    const handleSubmit = () => {
        GetTimeActivity()
        setIsLoading(true)

        const token = localStorage.getItem("token")
        let payload = {}
        payload = {
            "emailid": editFellow?.emailid?.trim(),
            "userType": editFellow?.userType,
            "name": editFellow?.name?.trim(),
            "phoneNumber": editFellow?.phoneNumber,
            "status": editFellow?.status,
            "assignedModules": assignedModuleIds,
            "submodule": 'FELLOWSHIP'

        }
        console.log("[handleSubmit] Payload:", payload); // ✅ Debug log


        const userId = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + '/updateUser?appname=' + appname + '&userid=' + id + "&pathologistid=" + userId + "&token=" + token,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (response?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        setIsLoading(false);


                        setTimeout(() => {
                            setSuccess(true)
                        }, 300);

                        // getFellowInfo();
                    }
                }

            });
    }


    const handleUpdate = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            handleSubmit();
        }
    }
    console.log('editFellow', editFellow)
    const createuser = async () => {
        setIsLoading(true)
        const isValid = formvalidation();
        if (!isValid) {
            return false
        }
        // GetTimeActivity()   
        let payload = {}
        payload = {
            "emailid": editFellow?.emailid?.trim(),
            "userType": editFellow?.userType,
            "name": editFellow?.name?.trim(),
            "phoneNumber": editFellow?.phoneNumber,
            "status": "ACTIVE"
        }
        const userId = localStorage.getItem("userId")
        axios({
            method: 'POST',
            url: lambda + "/addUser?appname=" + appname + "&userid=" + userId,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.result", response)
                    if (response?.data?.result === "User already exists" || response?.data?.result === "Emailid already exists") {
                        setIsLoading(false)
                        setExistMsg(true)

                    }
                    else if (response?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);
                        // setToastMessage("User Details Created Successfully")
                        // setTimeout(() => {
                        //     navigate("/users"); // Trigger API call AFTER toast is displayed
                        // }, 2000);
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()
        if (id) {
            navigate({
                pathname: "/fellows",
                state: { search: true }
            });
        } else {
            navigate("/fellows")
        }
    }


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months start at 0
        const year = String(date.getFullYear()).slice(-2); // Last 2 digits of year
        return `${day}-${month}-${year}`;
    };

    // const fetchModuleInfoData = () => {
    //     // setIsLoading(true);
    //     const token = localStorage.getItem("token")
    //     const userid = localStorage.getItem("userId")
    //     let params = {
    //         appname,
    //         // assetcount: itemsPerPage,
    //         // pageNumber: page,
    //         // search: searchQuery,
    //         token: token,
    //         pageName: 'ACTIVE',
    //         type: "Learning Module",
    //         // moduleType:!type?"user":'all',
    //         userid: userid,
    //         submodule: "FELLOWSHIP"

    //     }


    //     axios
    //         .get(`${lambda}/moduleInfo`, {
    //             params: params
    //         })
    //         .then((response) => {
    //             const result = response?.data?.result;
    //             if (result === "Invalid token or Expired") {
    //                 // handle invalid token if needed
    //                 return;
    //             }
    //             setModules(result?.data)

    //             console.log("API Response:", result);

    //         })
    //         .catch((err) => console.error("API error:", err))
    //     // .finally(() => setLoading(false));
    // };

    const fetchModuleInfoData = async () => {
        try {
            console.log("[fetchModuleInfoData] API started");

            const token = localStorage.getItem("token");
            const userid = localStorage.getItem("userId");

            const params = {
                appname,
                token,
                pageName: "ACTIVE",
                type: "Learning Module",
                userid,
                submodule: "FELLOWSHIP"
            };

            const response = await axios.get(`${lambda}/moduleInfo`, { params });
            console.log("[fetchModuleInfoData] Response:", response);

            const result = response?.data?.result;

            if (!result) {
                console.warn("[fetchModuleInfoData] Empty result");
                setModules([]);
                return;
            }

            if (result === "Invalid token or Expired") {
                console.warn("[fetchModuleInfoData] Invalid token");
                setShowSessionPopupup(true);
                return;
            }

            if (Array.isArray(result.data)) {
                setModules(result.data); // 👈 IMPORTANT


                const moduleOptions = Array.isArray(result.data)
                    ? result.data.map(item => ({
                        value: item.moduleid,
                        label: item.name,
                        description: item.description
                    }))
                    : [];
                setModuleOptions(moduleOptions)
                console.log("[fetchModuleInfoData] Modules set:", result.data);
            } else {
                setModules([]);
            }

        } catch (error) {
            console.error("[fetchModuleInfoData] API error:", error);
            setModules([]);
        }
    };




    // const selectedModules =
    //     Array.isArray(editFellow?.assignedModules) && moduleOptions.length > 0
    //         ? moduleOptions.filter(option =>
    //             editFellow.assignedModules.includes(String(option.value))
    //         )
    //         : [];

    // useEffect(() => {
    //     if (
    //         Array.isArray(editFellow?.assignedModules) &&
    //         editFellow.assignedModules.length > 0 &&
    //         Array.isArray(moduleOptions) &&
    //         moduleOptions.length > 0
    //     ) {
    //         const matched = moduleOptions.filter(opt =>
    //             editFellow.assignedModules.includes(opt.value)
    //         );

    //         console.log("Matched selected modules:", matched);
    //         setSelectedModules(matched);
    //     }
    // }, [editFellow?.assignedModules, moduleOptions]);

    console.log("modulessssssssss", modules,)
    console.log("selectedModules", selectedModules,)
    console.log("moduleOptions", moduleOptions,)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {!invalidContent &&

                    <div className="main-content user-management create-user submitted-module-table edit-follow" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">{id === undefined ? "ADD USER" : "EDIT Fellow"}</h4>
                                                {/* <p className="menu-path" id="breadcrumb-path">
                                                    <span>User Management</span> / <b id="breadcrumb-action">{id === undefined ? "ADD USER" : "EDIT USER"}</b>
                                                </p> */}
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">back</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">
                                    {!loader && editFellow && Object.keys(editFellow)?.length > 0 ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                {/* Row 1: Name & User Type */}
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">NAME</label>
                                                            <input id="name" name="name" placeholder="Enter Name" type="text" className="form-control" aria-invalid="false" onChange={handleChange} value={editFellow?.name} disabled />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label" htmlFor="usertype-select">USER TYPE</label>
                                                            <input disabled id="usertype-select" className="form-control" name="userType" onChange={handleChange} value={editFellow?.userType} />
                                                            <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{typeError}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Row 2: Email & Subscription Type */}
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">E-MAIL ID</label>
                                                            <input id="email" name="emailid" placeholder="Enter Your Email" type="email" className="form-control" aria-invalid="false" value={editFellow?.emailid} disabled={id !== undefined} onChange={handleChange} />
                                                            <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">Subscription Type</label>
                                                            <input name="subscriptionTier" type="text" className="form-control" aria-invalid="false" value={editFellow?.subscriptionTier} disabled />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Row 3: Contact Number & Start Date */}
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">CONTACT NUMBER</label>
                                                            <input id="contact-number" className="form-control" type="tel" name="phoneNumber" value={editFellow?.phoneNumber} placeholder="Enter Phone Number" disabled onChange={handleChange} />
                                                            <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{IdcError}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">Start Date</label>
                                                            <input type="text" className="form-control" value={formatDate(editFellow?.subscriptionStartDate)} disabled />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Row 4: End Date & Assign Modules */}
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">End Date</label>
                                                            <input type="text" className="form-control" value={formatDate(editFellow?.subscriptionEndDate)} disabled />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label" htmlFor="usertype-select">
                                                                Assign Modules<span className="required">*</span>
                                                            </label>

                                                            <Select
                                                                isMulti
                                                                options={moduleOptions}   // full dropdown list
                                                                value={selectedModules}   // selected items (edit mode)

                                                                components={{
                                                                    MultiValueRemove: () => null,
                                                                }}
                                                                isMultiValueRemovable={false}
                                                                isClearable={false}
                                                                onChange={handleModuleChange}
                                                            />


                                                            <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{moduleError}</span>




                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="">
                                                <DataTable
                                                    columns={columns}
                                                    keyField='value'
                                                    data={selectedModules}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    responsive
                                                    persistTableHead
                                                    striped
                                                    subHeaderAlign="right"
                                                    defaultSortField="label"
                                                    noDataComponent={
                                                        <div className="text-center py-5">
                                                            <p className="text-muted">No modules assigned yet</p>
                                                        </div>
                                                    }
                                                    paginationRowsPerPageOptions={[5, 10, 15, 25]}
                                                    paginationPerPage={5}
                                                />
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="submit" onClick={e => id === undefined ? handleAddUser(e) : handleUpdate(e)}>

                                                        {isLoading && (
                                                            <img src={rotate_right} className="loading-icon me-2" id="loginPwdLoading" alt="loading" />
                                                        )}
                                                        {id === undefined ? "Create" : "Update"}
                                                    </button>
                                                </div>
                                                {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                            </div>
                                        </>
                                    ) : (


                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                }



            </div>
            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <SweetAlert
                show={existmsg}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Email already exists"}
                onConfirm={e => setExistMsg(false)}
                id="error-alert"
            ></SweetAlert>
            <SweetAlert
                show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Modules assigned successfully"}
                onConfirm={e => onConfirm()}
                id="error-alert"
            ></SweetAlert>
            <SweetAlert
                show={showDeleteAlert}
                warning
                showCancel
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                onConfirm={confirmDeleteModule}
                onCancel={() => {
                    setShowDeleteAlert(false);
                    setModuleToDelete(null);
                }}
            >
                You want to delete this module?
            </SweetAlert>


        </>
    );
};

export default Fellow;